import { useState } from "react";
import { Row, Col, Divider, Skeleton, Checkbox, Button, Drawer } from "antd";
import StrikethroughPrice from "@general/strikethroughPrice";
import UserContract from "@general/userContract";
import SafeHtml from "@general/safeHtml";

const MtFirstStep = ({ packageDetails, loading, onContractSigned }) => {
  const [userContractDrawer, setUserContractDrawer] = useState(false);
  const [contractChekBox, SetContractChekbox] = useState(false);
  const openContractDrawer = () => {
    setUserContractDrawer(true);
  };
  return (
    <div
      className={`${
        loading ? "single-package-wrapper-loading" : "single-package-wrapper"
      }`}
    >
      {loading ? (
        <>
          <Skeleton active round />
          <Skeleton active round />
        </>
      ) : (
        <>
          {packageDetails?.contract && (
            <Drawer
              title={"تعهدنامه استفاده از اتاق جلسات"}
              placement="top"
              open={userContractDrawer}
              onClose={() => setUserContractDrawer(false)}
              height={450}
            >
              <UserContract
                contract={packageDetails?.contract}
                onCloseDrawer={() => setUserContractDrawer(false)}
              />
            </Drawer>
          )}

          <div className="single-package-name">{packageDetails?.name}</div>
          {packageDetails?.description && (
            <>
              <Divider orientation="right">توضیحات</Divider>
              <SafeHtml
                content={packageDetails.description}
                className="single-package-description"
              />
            </>
          )}
          <Divider orientation="right">مشخصات</Divider>
          <div className="single-package-details">
            <Row gutter={20} style={{ width: "100%" }}>
              <Col xs={12}>
                <div className="single-package-duration">
                  <span>مدت زمان: </span>
                  <span>{packageDetails?.sessions + " جلسه"}</span>
                </div>
              </Col>
              <Col xs={12}>
                <StrikethroughPrice
                  strikethroughRial={packageDetails?.strikethroughRial}
                  amountRial={packageDetails?.amountRial}
                />
              </Col>
            </Row>
            {packageDetails?.contract && (
              <Row style={{ marginTop: 20 }}>
                <Checkbox
                  checked={contractChekBox}
                  onChange={() => {
                    SetContractChekbox(!contractChekBox);
                    onContractSigned();
                  }}
                >
                  <div className="single-package-contract-checkbox">
                    <Button
                      type="link"
                      style={{ fontWeight: "bold" }}
                      onClick={openContractDrawer}
                    >
                      تعهدنامه
                    </Button>
                    مربوط به استفاده از اتاق جلسات صفاتک را مطالعه کرده و شرایط
                    آن را قبول میکنم.
                  </div>
                </Checkbox>
              </Row>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MtFirstStep;
